module.exports = __webpack_public_path__ + "img/brushstroke.8b8f7c15.png";